import * as angular from 'angular';



export function popWindow(href: string, id: string) {
    window.open(href, id,
        'width=1200, height=800, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no');

}
/**
 * @ngdoc directive
 * @name popout
 * @restrict CA
 *
 * @description Causes a click to pop open a new window
 *
 * @param {boolean} popout Optional expression to determine whether click should open a new window
 */
export default angular.module('directives.popout', [])
    .directive('popout', function popoutDirective() {
        return {
            link(scope, element, attrs) {
                element.bind('click', event => {
                    if(scope.$eval(attrs.popout) === false)
                        return;
                    popWindow(attrs.href, attrs.id);
                    event.preventDefault();
                });
            }
        };
    })
    .name;
